import '../styles/modal.scss';
import {createApp} from 'vue';
import Modal from "./Modal.vue";
import {createI18n} from 'vue-i18n'

const messages = {
    fr: {
        'Parution': 'Parution',
        'EAN physique': 'EAN papier',
        'EAN numérique': 'EAN numérique',
        'Livre papier': 'Livre papier',
        'Livre numérique': 'Livre numérique',
        'Promo': 'Promo',
        'Mention prix France': '* Prix éditeur de vente au public (ou prix catalogue en l’absence de prix public éditeur) pour la France métropolitaine',
        'Mention prix Belgique': '* Prix éditeur de vente au public (ou prix catalogue en l’absence de prix public éditeur) pour la Belgique',
        'Mention promo': 'Promotion valable jusqu\'au {date}',
        'Commander en ligne': 'Commander en ligne',
        'Afficher la carte': 'Afficher la carte',
        'Trouver une librairie': 'Trouver une librairie',
        'Voir tout': 'Voir tout',
        'Rechercher dans cette zone': 'Rechercher dans cette zone',
        'Aucune librairie trouvée autour de votre localisation.': 'Aucune librairie trouvée autour de votre localisation.',
        'Élargissez votre recherche en utilisant la carte.': 'Élargissez votre recherche en utilisant la carte.'
    },
    en: {}
}

const i18n = createI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: messages
})

const app = createApp(Modal);
app.use(i18n);
app.mount('#app');
